module.exports = __webpack_public_path__ + "media/images/application/placeholder/placeholder-3x4-70cbcfe32e7d49e3fc37eb2f05592e83.jpg";